import capitalize from "./capitalize";
const treatData = ({ content, title, date, excerpt }) => ({
  bodyText: content?.rendered || "",
  headerText: capitalize(title?.rendered),
  postExcerpt: excerpt?.rendered || "",
  date,
});
export default (response) => [...response.map((e) => ({ ...treatData(e) }))];
